import api from './api';

export interface SopStep {
    id: number;
    step_text: string;
    step_order: number;
    instructions?: string;
    is_required: boolean;
    requires_photo: boolean;
    requires_comment: boolean;
}

export interface Sop {
    id: number;
    title: string;
    description?: string;
    category: string;
    estimated_duration?: number;
    status: string;
    steps: SopStep[];
}

export interface SopCompletion {
    id: number;
    sop_id: number;
    job_id?: number; // Job ID from jobcard_jobs table
    completed_by: number; // User ID
    store_id?: number;
    ksa_number: string;
    status: string;
    started_at: string;
    completed_at?: string;
    duration_minutes?: number;
    signature?: string;
    notes?: string;
    sop: Sop;
    completion_steps: SopCompletionStep[];
    job?: {
        id: number;
        description: string;
        job_card_id: number;
        task_type?: string;
        sop_completion_id?: number;
        sop_data?: any;
        job_card?: {
            id: number;
            job_number?: string;
            store_id: number;
            date: string;
            time_in: string;
            time_out: string;
            travel_distance: number;
            order_number?: string;
        };
    };
}

export interface SopCompletionStep {
    id: number;
    sop_completion_id: number;
    step_id: number;
    is_completed: boolean;
    comment?: string;
    completed_at?: string;
    sop_step: SopStep;
}

export const getSops = async () => {
    const response = await api.get('/sops');
    return response.data;
};

export const getSopsByCategory = async () => {
    const response = await api.get('/sops/by-category');
    return response.data;
};

export const getSop = async (id: number) => {
    const response = await api.get(`/sops/${id}`);
    return response.data;
};

export const startSopCompletion = async (sopId: number, data: {
    completed_by: string | number; // Accept both string and number
    job_id?: number; // Job ID from jobcard_jobs table
    store_id?: number;
    ksa_number: string;
    technician_name: string;
}) => {
    const response = await api.post(`/sops/${sopId}/start`, data);
    return response.data;
};

export const updateSopStep = async (stepId: number, data: {
    is_completed: boolean;
    comment?: string;
}) => {
    const response = await api.put(`/sop-completion-steps/${stepId}`, data);
    return response.data;
};

export const saveSopProgress = async (completionId: number, data: {
    steps: Array<{
        step_id: number;
        is_completed: boolean;
        comment?: string;
    }>;
}) => {
    const response = await api.put(`/sop-completions/${completionId}/progress`, data);
    return response.data;
};

export const finalizeSopCompletion = async (completionId: number, data: {
    signature?: string;
    final_notes?: string;
    technician_name: string;
}) => {
    const response = await api.post(`/sop-completions/${completionId}/finalize`, data);
    return response.data;
};

export const getSopCompletion = async (completionId: number) => {
    const response = await api.get(`/sop-completions/${completionId}`);
    return response.data;
};
